export enum ActivationUnits {
    Percent = "%",
    PercentPoints = "pp",
}

export const addMetric =
    (unit = "") =>
    (value: number | string) => {
        if (unit === ActivationUnits.Percent) {
            return `${value}${unit}`;
        }

        if (unit === ActivationUnits.PercentPoints) {
            return `${value} ${unit}`;
        }

        return String(value);
    };

export const addPercent = addMetric(ActivationUnits.Percent);
export const addPercentPoint = addMetric(ActivationUnits.PercentPoints);

export const toPercent = (value: number): string => {
    const percent = value > 1 ? value : value * 100;
    return `${percent}%`;
};
